// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-slope-chart {
  text-align: center;
  margin: var(--wm-feature-details-margin);
}
wm-slope-chart .webmapp-slopechart-canvas-container {
  margin: 0 auto;
  width: 100%;
  height: 180px;
}
wm-slope-chart .webmapp-slopechart-canvas-container .webmapp-slopechart-canvas {
  margin: 0 auto;
  width: 100% !important;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-slope-container {
  margin: 15px 0 10px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-right: 15px;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-slope-container .webmapp-slopechart-legend-slope-label {
  flex-grow: 1;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-slope-container .webmapp-slopechart-legend-slope-label::first-letter {
  text-transform: uppercase;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-slope-container .webmapp-slopechart-legend-slope-bar {
  height: 4px;
  flex-grow: 10;
  background: linear-gradient(to right, rgb(67, 227, 9) 0%, rgb(195, 255, 0) 25%, rgb(255, 239, 10) 50%, rgb(255, 174, 0) 75%, rgb(196, 30, 4) 100%);
  overflow: visible;
  position: relative;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-slope-container .webmapp-slopechart-legend-slope-bar .webmapp-slopechart-legend-slope-selected-container {
  position: absolute;
  bottom: -5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transform: translateX(-50%);
  transition: left 500ms;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-slope-container .webmapp-slopechart-legend-slope-bar .webmapp-slopechart-legend-slope-selected-container .webmapp-slopechart-legend-slope-selected-dot {
  width: 14px;
  height: 14px;
  border-radius: 10px;
  border: 2px solid #fff;
  background: #000;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-surface-container {
  margin: 10px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-surface-container .webmapp-slopechart-legend-surface {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-surface-container .webmapp-slopechart-legend-surface .webmapp-slopechart-legend-surface-dot {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  display: inline-block;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-surface-container .webmapp-slopechart-legend-surface .webmapp-slopechart-legend-surface-label {
  margin-left: 5px;
}
wm-slope-chart .webmapp-slopechart-legend-container .webmapp-slopechart-legend-surface-container .webmapp-slopechart-legend-surface .webmapp-slopechart-legend-surface-label::first-letter {
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/slope-chart/slope-chart.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,wCAAA;AACF;AAAE;EACE,cAAA;EACA,WAAA;EACA,aAAA;AAEJ;AADI;EACE,cAAA;EACA,sBAAA;AAGN;AAEI;EACE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAAN;AACM;EACE,YAAA;AACR;AAAQ;EACE,yBAAA;AAEV;AACM;EACE,WAAA;EACA,aAAA;EACA,kJAAA;EAQA,iBAAA;EACA,kBAAA;AANR;AAOQ;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;AALV;AAMU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAJZ;AASI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AAPN;AAQM;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AANR;AAOQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AALV;AAOQ;EACE,gBAAA;AALV;AAMU;EACE,yBAAA;AAJZ","sourcesContent":["wm-slope-chart {\n  text-align: center;\n  margin: var(--wm-feature-details-margin);\n  .webmapp-slopechart-canvas-container {\n    margin: 0 auto;\n    width: 100%;\n    height: 180px;\n    .webmapp-slopechart-canvas {\n      margin: 0 auto;\n      width: 100% !important;\n    }\n  }\n\n  .webmapp-slopechart-legend-container {\n    .webmapp-slopechart-legend-slope-container {\n      margin: 15px 0 10px;\n      width: 100%;\n      display: flex;\n      justify-content: space-evenly;\n      align-items: center;\n      padding-right: 15px;\n      .webmapp-slopechart-legend-slope-label {\n        flex-grow: 1;\n        &::first-letter {\n          text-transform: uppercase;\n        }\n      }\n      .webmapp-slopechart-legend-slope-bar {\n        height: 4px;\n        flex-grow: 10;\n        background: linear-gradient(\n          to right,\n          rgb(67, 227, 9) 0%,\n          rgb(195, 255, 0) 25%,\n          rgb(255, 239, 10) 50%,\n          rgb(255, 174, 0) 75%,\n          rgb(196, 30, 4) 100%\n        );\n        overflow: visible;\n        position: relative;\n        .webmapp-slopechart-legend-slope-selected-container {\n          position: absolute;\n          bottom: -5px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          flex-direction: column;\n          transform: translateX(-50%);\n          transition: left 500ms;\n          .webmapp-slopechart-legend-slope-selected-dot {\n            width: 14px;\n            height: 14px;\n            border-radius: 10px;\n            border: 2px solid #fff;\n            background: #000;\n          }\n        }\n      }\n    }\n    .webmapp-slopechart-legend-surface-container {\n      margin: 10px 0;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      justify-content: space-evenly;\n      .webmapp-slopechart-legend-surface {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0 5px;\n        .webmapp-slopechart-legend-surface-dot {\n          width: 10px;\n          height: 10px;\n          border-radius: 10px;\n          display: inline-block;\n        }\n        .webmapp-slopechart-legend-surface-label {\n          margin-left: 5px;\n          &::first-letter {\n            text-transform: uppercase;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
